import React, { useState, useEffect, useCallback, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";
import Input from "../../components/Input";
import Select from "../../components/Select";
import { SaleService } from "../../services/SaleService";
import { TypesService } from "../../services/TypesService";
import { ReportadasService } from "../../services/ReportadasService";
import { AuthContext } from "../../context/AuthContext";

const RegistrarReportada = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const { id, j } = useParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [gContrat, setGContrat] = useState("");
  const [contratAssinged, setContratAssinged] = useState("");
  const [reportedSelected, setReportedSelected] = useState("");
  const [tematicSelected, setTematicSelected] = useState("");
  const [callSelected, setCallSelected] = useState("");
  const [installSelected, setInstallSelected] = useState("");
  const [notes, setNotes] = useState("");
  const [statusSelected, setStatusSelected] = useState("");
  const [tematicList, setTematicList] = useState([]);
  const [data, setData] = useState({});
  const [reportadas, setReportadas] = useState([]);
  const [statusClientList, setStatusClientList] = useState([]);
  const [errors, setErrors] = useState({});
  const onlyRead = j === "only";

  const handleBackToList = () => {
    navigate("/admin/reportadas");
  };

  const fetchVenta = useCallback(async () => {
    if (loading) return;

    setLoading(true);
    try {
      const [responseTematic, responseStatus, responseAvance] = await Promise.all([
        TypesService.get({ token, table: 'tematico' }),
        TypesService.get({ token, table: 'estado_cliente' }),
        SaleService.fetchAvanceVentaPorId(token, id)
      ]);

      const ventaData = responseAvance.data.venta;

      if (ventaData && ventaData.id_estado_cliente !== 3 && !onlyRead) {
        navigate("/admin/reportadas");
        return;
      }

      const filteredStatus = responseStatus
        .filter(r => r.id !== 4)
        .map(r => ({ id: r.id, nombre: r.descripcion }));

      const responseReportadas = await ReportadasService.get({ token, vid: id });

      setStatusClientList(filteredStatus);
      setTematicList(responseTematic);
      setData(ventaData);
      setReportadas(responseReportadas);

    } catch (error) {
      console.error("Error al obtener la venta:", error);
    } finally {
      setLoading(false);
    }
  }, [id, token, navigate]); // Memorizamos la función

  useEffect(() => {
    if (id) {
      fetchVenta();
    }
  }, [id, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const isValid = validateForm(); if (!isValid) { setLoading(false); return; }
    try {
      const response = await ReportadasService.save({
        token: token,
        formData: {
          id_avance_venta: id,
          gContrat: gContrat,
          contratAssinged: contratAssinged,
          reportedSelected: reportedSelected,
          tematicSelected: tematicSelected,
          callSelected: callSelected,
          installSelected: installSelected,
          notes: notes,
          statusSelected: statusSelected,
          origen: 'web'
        }
      });

      if (response.success) {
        toast.success(response.message);
        setLoading(false);
        setGContrat("");
        setContratAssinged("");
        setReportedSelected("");
        setTematicSelected("");
        setCallSelected("");
        setInstallSelected("");
        setNotes("");
        setStatusSelected("");
        fetchVenta();
      } else {
        setError(response.message);
      }

    } catch (err) {
      console.log("Error al registrar el seguimiento", err);
      setError("Error al registrar el seguimiento.");
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!gContrat.trim()) {
      newErrors.gContrat = "El gestor contrata es obligatorio";
    } else if (gContrat.length > 50) {
      newErrors.gContrat = "No puede exceder los 50 caracteres";
    }

    if (!contratAssinged.trim()) {
      newErrors.contratAssinged = "La contrata asignada es obligatoria";
    }

    if (!reportedSelected || reportedSelected === "0") {
      newErrors.reportedSelected = "Debe seleccionar el tipo de reporte";
    }

    if (!tematicSelected || tematicSelected === "0") {
      newErrors.tematicSelected = "Debe seleccionar un temático";
    }

    if (!callSelected || callSelected === "0") {
      newErrors.callSelected = "Debe seleccionar el estado de la llamada";
    }

    if (!installSelected || installSelected === "0") {
      newErrors.installSelected = "Debe indicar si está instalado";
    }

    if (!statusSelected || statusSelected === "0") {
      newErrors.statusSelected = "El estado del cliente es obligatorio";
    }

    if (!notes.trim()) {
      newErrors.notes = "La observación es obligatoria";
    } else if (notes.length < 10) {
      newErrors.notes = "La observación debe ser más detallada (mín. 10 carac.)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <span className="breadcrumb-link" onClick={handleBackToList}>
          ← Listado de Reportados
        </span>
        <span className="breadcrumb-current"> / Reportados</span>
      </div>
      <div className="nuevo-producto-card">
        <div className="flex justify-between gap-20">
          <div className="w-70">
            <span className="nueva-venta-instalada-title"> Registrar Seguimiento</span>
            <div className="dashboard-card nueva-venta-responsive">

              <form
                className="nueva-venta-form"
                onSubmit={handleSubmit}
                autoComplete="off"
              >

                {error && <div className="error-message">{error}</div>}

                <div className="form-grid-3">
                  <div className="">
                    <Input title="Gestor Contrata" value={gContrat} setValue={setGContrat} placeholder="Ingrese" disable={onlyRead} required={true} />
                    {errors.gContrat && <span className="error">{errors.gContrat}</span>}
                  </div>
                  <div className="">
                    <Input title="Contrata asignada" value={contratAssinged} setValue={setContratAssinged} placeholder="Ingrese" disable={onlyRead} required={true} />
                    {errors.contratAssinged && <span className="error">{errors.contratAssinged}</span>}
                  </div>
                  <div className="">
                    <Select title="Reportado" value={reportedSelected} setValue={setReportedSelected} options={[
                      {
                        id: 0,
                        nombre: 'Seleccione'
                      },
                      {
                        id: 1,
                        nombre: 'Bien reportado'
                      },
                      {
                        id: 2,
                        nombre: 'Mal reportado'
                      },
                    ]} disable={onlyRead} required={true} />
                    {errors.reportedSelected && <span className="error">{errors.reportedSelected}</span>}
                  </div>
                </div>

                <div className="form-grid-3">
                  <div className="">
                    <Select title="Temático" value={tematicSelected} setValue={setTematicSelected} required={true} options={[
                      {
                        id: 0,
                        nombre: 'Seleccione'
                      },
                      ...tematicList
                    ]} disable={onlyRead} />
                    {errors.tematicSelected && <span className="error">{errors.tematicSelected}</span>}
                  </div>
                  <div className="">
                    <Select title="Llamada" value={callSelected} setValue={setCallSelected} options={[
                      {
                        id: 0,
                        nombre: 'Seleccione'
                      },
                      {
                        id: 1,
                        nombre: 'NO CONTACTO'
                      },
                      {
                        id: 2,
                        nombre: 'CONTACTO EFECTIVO'
                      },
                    ]} disable={onlyRead} required={true} />
                    {errors.callSelected && <span className="error">{errors.callSelected}</span>}
                  </div>
                  <div className="">
                    <Select title="Instalado" value={installSelected} setValue={setInstallSelected} options={[
                      {
                        id: 0,
                        nombre: 'Seleccione'
                      },
                      {
                        id: 1,
                        nombre: 'Si'
                      },
                      {
                        id: 2,
                        nombre: 'No'
                      },
                    ]} disable={onlyRead} required={true} />
                    {errors.installSelected && <span className="error">{errors.installSelected}</span>}
                  </div>
                </div>

                <div className="form-grid-3">
                  <div className="">
                    <Input title="Observación" value={notes} setValue={setNotes} placeholder="" type="textarea" disable={onlyRead} required={true} />
                    {errors.notes && <span className="error">{errors.notes}</span>}
                  </div>
                  <div className="">
                    <Select title="Estado" value={statusSelected} setValue={setStatusSelected} options={
                      [
                        {
                          id: 0,
                          nombre: 'Seleccione'
                        },
                        ...statusClientList
                      ]} disable={onlyRead} required={true} />
                    {errors.statusSelected && <span className="error">{errors.statusSelected}</span>}
                  </div>
                  <div >
                    <div className="">
                      <button
                        className="btn btn-primary w-full mt-40"
                        type="submit"
                        disabled={loading || onlyRead}
                      >
                        {loading
                          ? "Procesando..."
                          : "Registrar"
                        }
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="ventas-table-wrapper pt-40">
              <table className="ventas-table">
                <thead>
                  <tr>
                    <th>F. Gestión</th>
                    <th>Estado</th>
                    <th>Temático</th>
                    <th>Llamada</th>
                    <th>Instalado</th>
                    <th>Observación</th>

                    <th># Contac</th>
                  </tr>
                </thead>
                <tbody>
                  {reportadas.map((r, k) => {
                    const uniqueKey = r.id ? `${r.id}-${k}` : k;

                    const tematico = tematicList.find((t) => String(t.id) === String(r.tematico_id));

                    return (
                      <tr key={uniqueKey}>
                        <td>{r.fecha ? new Date(r.fecha).toLocaleDateString() : 'N/A'}</td>
                        <td>{r.estado_cliente}</td>
                        <td>{tematico ? tematico.nombre : ''}</td>
                        <td>
                          {r.llamada === null || typeof r.llamada === 'undefined'
                            ? ''
                            : (r.llamada == 1 ? 'No contacto' : 'Contacto Efectivo')}
                        </td>
                        <td>{r.instalado == 1 ? 'Si' : 'No'}</td>
                        <td>{r.observaciones}</td>
                        {/* <td>{r.nombre_responsable}</td> */}
                        <td>{r.item_correlativo}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

          </div>
          <div className="w-30 bl-1">
            {
             data?.id !== undefined && (
                <div className="container-gray">
                  <p>Asesor - {`${data.nombre_vendedor} ${data.apellido_vendedor}`}</p>
                 <p>SUPERVISOR - {data.supervisor?.nombre || ''}</p>
                  <p>CÓDIGO CLIENTE - {data.cod_cliente}</p>
                  <p>ESTADO - REPORTADO</p>
                  <p>NÚMERO DOCUMENTO - {data.numero_documento}</p>
                  <p>NOMBRES COMPLETOS / RAZÓN SOCIAL</p>
                  <p>{`${data.nombre_cliente || ''} ${data.razon_social}`}</p>
                  <p>TELÉFONO: {data.telefono_1}</p>
                  <p>TELÉFONO: {data.telefono_2}</p>
                  <p>tipificación | {data.tipificacion_reportada}</p>
                  <p>subtipificación</p>
                  <p>{data.subtipificacion_reportada}</p>
                  <p>Observación</p>
                  <p>{data.observacion}</p>
                  {
                    !onlyRead && data.id_estado_cliente != 4 && reportadas.length > 0 && (
                      <button
                        className="btn btn-orange"
                        type="button"
                        disabled={loading}
                        onClick={async () => {
                          if (!window.confirm("¿Está seguro de anular este avance?")) return;
                          setLoading(true);
                          await ReportadasService.disable({
                            token: token,
                            formData: {
                              avid: id,
                              vid: data.id_venta && data.id_venta !== "" ? data.id_venta : 0,
                              disable: true,
                              status: 4,
                            }
                          });
                          setLoading(false);
                          fetchVenta();
                          navigate(`/admin/reportadas`);
                        }}
                      >
                        Anular
                      </button>
                    )
                  }
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrarReportada;
